var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "81 208 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii1s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 278.446C200 286.422 196.823 294.071 191.168 299.711C185.513 305.351 177.843 308.519 169.846 308.519C164.986 308.528 160.197 307.348 155.9 305.082L162.308 324.361C162.532 325.005 162.595 325.694 162.492 326.368C162.389 327.042 162.122 327.68 161.715 328.228C161.323 328.774 160.806 329.22 160.207 329.528C159.607 329.836 158.943 329.998 158.269 330H129.731C129.057 329.998 128.393 329.836 127.793 329.528C127.194 329.22 126.677 328.774 126.285 328.228C125.878 327.68 125.611 327.042 125.508 326.368C125.405 325.694 125.468 325.005 125.692 324.361L132.1 305.082C127.803 307.348 123.014 308.528 118.154 308.519C110.157 308.519 102.487 305.351 96.8319 299.711C91.1769 294.071 88 286.422 88 278.446C88 249.661 140.608 215.775 142.815 214.325C143.174 214.112 143.583 214 144 214C144.417 214 144.826 214.112 145.185 214.325C147.392 215.775 200 249.661 200 278.446Z",
    fill: "#1B191A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 278.446C200 286.422 196.823 294.071 191.168 299.711C185.513 305.351 177.843 308.519 169.846 308.519C164.986 308.528 160.197 307.348 155.9 305.082L162.308 324.361C162.532 325.005 162.595 325.694 162.492 326.368C162.389 327.042 162.122 327.68 161.715 328.228C161.323 328.774 160.806 329.22 160.207 329.528C159.607 329.836 158.943 329.998 158.269 330H129.731C129.057 329.998 128.393 329.836 127.793 329.528C127.194 329.22 126.677 328.774 126.285 328.228C125.878 327.68 125.611 327.042 125.508 326.368C125.405 325.694 125.468 325.005 125.692 324.361L132.1 305.082C127.803 307.348 123.014 308.528 118.154 308.519C110.157 308.519 102.487 305.351 96.8319 299.711C91.1769 294.071 88 286.422 88 278.446C88 249.661 140.608 215.775 142.815 214.325C143.174 214.112 143.583 214 144 214C144.417 214 144.826 214.112 145.185 214.325C147.392 215.775 200 249.661 200 278.446Z",
    fill: "url(#paint0_linear1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii1s",
    x: 88,
    y: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear1",
    x1: 129.349,
    y1: 214,
    x2: 129.349,
    y2: 330,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpades);
export default __webpack_public_path__ + "static/media/spades.76f47133d6db6f38fc4dd04024b08b96.svg";
export { ForwardRef as ReactComponent };